import {ReactNode, useEffect} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {useLocation} from "react-router-dom";

import {Error} from "@/components/Error/Error";
import Content from "@/components/Layout/Content/Content";
import Header from "@/components/Layout/Header/Header";

const ScrollToTop = (): JSX.Element => {
  // Extracts pathname property(key) from an object
  const {pathname, search} = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return <div></div>;
};

function Layout({children}: {children: ReactNode}): JSX.Element {
  useEffect(() => {
    // Désactiver la restauration automatique de la position du scroll
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Scroll vers le haut à chaque rechargement
    window.scrollTo(0, 0);

    // Nettoyage de l'effet
    return () => {
      window.history.scrollRestoration = "auto"; // Réinitialiser le comportement par défaut
    };
  }, []);
  return (
    <>
      <ScrollToTop />
      <Header />

      <Content>
        <ErrorBoundary
          fallback={
            <Error
              text="Une erreur est survenu, veuillez réessayer"
              buttonToRefresh={true}
            />
          }>
          {children}
        </ErrorBoundary>
      </Content>
    </>
  );
}

export default Layout;
